module.exports = __webpack_public_path__ + "img/pr.56af82c0.png";